import gql from 'graphql-tag'

export const GET_PRODUCT_CATEGORY_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
		$query: String
  ) {
    getProductCategoryPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleRu
        titleKg
      }
    }
  }
`

export const GET_PRODUCT_CATEGORY_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProductCategory (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleRu
      titleKg
      icon
      image
    }
  }
`;

export const GET_ALL_PRODUCT_CATEGORY_QUERY = gql`
  query {
    getAllProductCategories {
      id
      titleEn
      titleRu
      titleKg
    }
  }
`

